import { render, staticRenderFns } from "./ShopProductGroupbuyGroupRecord.vue?vue&type=template&id=232a28c9&scoped=true"
import script from "./ShopProductGroupbuyGroupRecord.vue?vue&type=script&lang=js"
export * from "./ShopProductGroupbuyGroupRecord.vue?vue&type=script&lang=js"
import style0 from "./ShopProductGroupbuyGroupRecord.vue?vue&type=style&index=0&id=232a28c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232a28c9",
  null
  
)

export default component.exports